import { createBrowserRouter, redirect } from "react-router-dom";
import { lazy } from "react";

import AuthGuard from "./auth/AuthGuard";

import dashboardRoutes from "./views/dashboard/dashboardRoutes";
import pagesRoutes from "./views/pages/pagesRoutes";
import iconsRoutes from "./views/icons/iconsRoutes";
import formsRoutes from "./views/forms/formsRoutes";
import chartsRoute from "./views/charts/chartsRoute";
import uiKitsRoutes from "./views/ui-kits/uiKitsRoutes";
import widgetsRoute from "./views/widgets/widgetsRoute";
import dataTableRoute from "./views/data-table/dataTableRoute";
import extraKitsRoutes from "./views/extra-kits/extraKitsRoutes";
import chatRoutes from "./views/app/chat/chatRoutes";
import inboxRoutes from "./views/app/inbox/inboxRoutes";
import invoiceRoutes from "./views/app/invoice/invoiceRoutes";
import contactRoutes from "./views/app/contact/contactRoutes";
import calendarRoutes from "./views/app/calendar/calendarRoutes";
import ecommerceRoutes from "./views/app/ecommerce/ecommerceRoutes";
import taskManagerRoutes from "./views/app/task-manager/taskManagerRoutes";
import TransactionsRoutes from "./views/transactions/TransactionsRoutes";
import Error404 from "./views/sessions/Error";
import sessionsRoutes from "./views/sessions/sessionsRoutes";
import SalesRoutes from './views/sales/SalesRoutes';
import ExpensesRoutes from "./views/expenses/ExpensesRoutes";
import CustomRoutes from "./views/Customers&Leads/CustomRoutes";
import ReportsRoutes from "./views/Reports/ReportsRoutes";
import EmployesRoutes from "./views/Employees/EmployesRoutes";
import TaxesRoutes from "./views/Taxes/TaxesRoutes";
import AppsRoutes from "./views/Apps/AppsRoutes";
import devisRoutes from "./views/Devis/devisRoutes";
import comptabiliteRoutes from "./views/comptabilite/comptabiliteRoutes";
import SettingsRoutes from "./views/Settings/SettingsRoutes";
import clientsRoutes from "./views/clients/ClientsRoutes";
import DocumentRoutes from "./views/Documents/DocumentRoutes";
const VerifyEmail = lazy(() => import("./views/Settings/VerifyEmail"));

export const protectedRoutes = [
  ...dashboardRoutes,
  ...uiKitsRoutes,
  ...formsRoutes,
  ...widgetsRoute,
  ...chartsRoute,
  ...dataTableRoute,
  ...extraKitsRoutes,
  ...pagesRoutes,
  ...iconsRoutes,
  ...invoiceRoutes,
  ...inboxRoutes,
  ...calendarRoutes,
  ...taskManagerRoutes,
  ...ecommerceRoutes,
  ...contactRoutes,
  ...chatRoutes,
  ...TransactionsRoutes,
  ...SalesRoutes,
  ...ExpensesRoutes,
  ...CustomRoutes,
  ...ReportsRoutes,
  ...EmployesRoutes,
  ...TaxesRoutes,
  ...AppsRoutes,
  ...devisRoutes,
  ...comptabiliteRoutes,
  ...SettingsRoutes,
  ...clientsRoutes,
  ...DocumentRoutes
];
const routes = createBrowserRouter([
  {
    element: <AuthGuard />,
    children: protectedRoutes
  },
  ...sessionsRoutes,
  { path: "/verify-email", element: <VerifyEmail /> },
  { path: "/", loader: () => redirect("/dashboard/v1") },
  { path: "*", element: <Error404 /> }
]);

export default routes;
